import React from "react";
import styled from "react-emotion";
import {
  color,
  space,
  width,
  borderBottom,
  borderColor,
  justifyContent,
} from "styled-system";
import { Row, Col } from "antd";

export const Wrapper = styled(Row, {
  shouldForwardProp: (prop) => !["borderBottom", "borderColor"].includes(prop),
})`
  ${color}
  ${space}
  ${borderBottom}
  ${borderColor}
  display: flex;
  font-family: 'proxima-nova', Sans-Serif;
`;

export const Section = styled(
  ({ flexDirection, ...rest }) => <Col {...rest} />,
  { shouldForwardProp: (prop) => !["justifyContent"].includes(prop) }
)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  ${justifyContent}
  ${width}
  ${space}

  ${({ wrappadding }) =>
    wrappadding &&
    `
    & > * {
      margin-top: ${wrappadding}px;
      margin-bottom: ${wrappadding}px;
    }
  `}
`;
